// @ts-strict-ignore
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { LMToolbarComponent } from '@toolbar/lm-toolbar.component';
import { LMFormatUtilService } from '@services/utils';
import { SohoBusyIndicatorDirective, SohoDataGridComponent } from 'ids-enterprise-ng';

@Component({
  selector:    'lm-list-audit-compare-panel',
  standalone: false,
  templateUrl: './lm-list-audit-compare-panel.component.html',
  styleUrls:   [ './lm-list-audit-compare-panel.component.css' ]
})
export class LMListAuditComparePanelComponent implements OnInit {

  @ViewChild(SohoDataGridComponent, { static: true }) dataGridComponent: SohoDataGridComponent;
  @ViewChild(LMToolbarComponent) toolBarComponent: LMToolbarComponent;
  @ViewChild(SohoBusyIndicatorDirective, { static: false }) sohoBusyIndicator!: SohoBusyIndicatorDirective;

  @Input() set changedValues(changedValues: Array<LMAuditCompareChangedValues>) {
    this._changedValues = changedValues;
    this.dataGridComponent.data = changedValues;
  }

  @Input() set emptyMessageTitle(emptyMessageTitle) {
    this._emptyMessageTitle = emptyMessageTitle;
    this.dataGridComponent.emptyMessage = { title: emptyMessageTitle };
  };

  @Input() title: string;

  @Input() set isColumnarAuditOutOfSyncWarning(showAuditOutOfSyncWarning) {
    this._showAuditOutOfSyncWarning = showAuditOutOfSyncWarning;
  }

  @Input() set showBusyIndicator(showBusyIndicator: boolean) {
    if (showBusyIndicator) {
      this.sohoBusyIndicator.open();
    } else {
      this.sohoBusyIndicator.close(false);
    }
  }

  @Input() uiLoadingIndicatorTimeout = 0;

  private _changedValues: Array<LMAuditCompareChangedValues>;
  private _emptyMessageTitle: string;
  public _showAuditOutOfSyncWarning = false;

  constructor(
    protected lmFormatUtilService: LMFormatUtilService
  ) {
    // no -op
  }

  ngOnInit() {
    this.build();
  }

    private build(): void {
       const customFormatter: SohoDataGridColumnFormatterFunction = (
            row: number,
            cell: any,
            fieldValue: any,
            columnDef: SohoDataGridColumn,
            rowData: LMAuditCompareChangedValues,
            api: SohoDataGridStatic
        ) => {
            if (rowData.IsRichText) {
                return Soho.Formatters.Editor(row, cell, fieldValue, columnDef, rowData, api);
            } else {
                return Soho.Formatters.Ellipsis(row, cell, fieldValue, columnDef, rowData, api);
            }
        };
        const headerColumns: SohoDataGridColumn[] = [
            {
                name:       Soho.Locale.translate('FieldName'),
                field:      'FieldName',
                sortable:   false,
                formatter:  'Ellipsis',
                singleline: true,
                minWidth: 100,
                width: 200,
                maxWidth: 200,
            },
            {
                name:       Soho.Locale.translate('OldValue'),
                field:      'FromValue',
                sortable:   false,
                singleline: true,
                minWidth: 100,
                width:   200,
                maxWidth: 200,
                formatter: customFormatter,
                renderTooltipHtmlContents: true,
                tooltip: (row, cell, value, rowData) => value
            },
            {
                name:       Soho.Locale.translate('NewValue'),
                field:      'ToValue',
                sortable:   false,
                singleline: true,
                minWidth: 100,
                width:   200,
                maxWidth: 200,
                formatter: customFormatter,
                renderTooltipHtmlContents: true,
                tooltip: (row, cell, value, rowData) => value
            }
        ];

        const changedValues = [];

        const gridOptions: SohoDataGridOptions = <SohoDataGridOptions> {
            columns:    headerColumns,
            dataset:    changedValues,
            selectable: false,
            paging:     false,
            rowReorder: true,
            rowHeight: 'short',
            enableTooltips: true
        };

        // Now using 'light datagrid header color
        gridOptions['headerBackgroundColor'] = 'light';

        this.dataGridComponent.gridOptions = gridOptions;
    }
}
